import React from "react";
// import './fullPageLoader.css';

export const FullPageLoader = () => {
  return <div id="cover-spin"></div>;
};
